import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallTable } from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

/** Adds the (static, placeholder) contracts card (#2222). */
export function addContractsCard(view: View<TestAppState, DragAndDropLayout>) {
  const contractsComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "contractsReportComponent",
      labels: ["contracts", "list"],
      description: "Shows a simple list of contracts.",
      title: "Contracts",
    },
  });

  contractsComponent.mapState(() => ({
    title: "Contracts",
    icon: "Description",
    items: [
      {
        label: "Name Test Contract 1",
        value: "PDF, contract-2025.pdf",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
      {
        label: "Name Test Contract 2",
        value: "TXT, contract-XXX.txt",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
    ],
    fixedHeight: "134px",
  }));
}
